import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DPFormField } from 'src/app/core/models/DPFormField';
import { DPFormFieldType } from 'src/app/core/models/enums/DPFormFieldType';
import { ApiService } from 'src/app/core/services/api.service';
import { FormParserService } from 'src/app/core/services/form-parser.service';

/**
 * Feedback modal.
 */
@Component({
  selector: 'app-feedback-modal',
  templateUrl: './feedback-modal.component.html',
  styleUrls: ['./feedback-modal.component.scss'],
})
export class FeedbackModalComponent implements OnInit {
  // Submit event emitter
  @Output() submit = new EventEmitter();

  // Modal dismiss event emitter
  @Output() dismiss = new EventEmitter();

  // Feedback form fields
  fields: DPFormField[] = [
    {
      type: DPFormFieldType.MultiLine,
      name: 'text',
      label: 'Question',
      rows: 5,
      colSpan: {
        desktop: 12,
        tablet: 12,
        mobile: 12,
      },
      required: true,
    },
  ];
  // Angular form object of Feedback form.
  form: UntypedFormGroup;
  error: string;
  success: boolean = false;

  constructor(private api: ApiService, private formParser: FormParserService) {}

  ngOnInit(): void {
    // Create feedback form
    this.form = this.formParser.createDynamicForm(this.fields, {}, true);
  }

  /**
   * Submit event handler.
   * This submits feedback to the server.
   * After submission shows Success or Error message.
   */
  submitFeedback() {
    this.api
      .submitFeedback({
        type: 'issue',
        text: this.form.value.text,
      })
      .subscribe(
        () => {
          this.success = true;
        },
        () => {
          this.error = 'Error occurred. Please try submitting again.';
        }
      );
  }

  /**
   * Close modal event handler.
   */
  dismissModal() {
    this.dismiss.emit();
  }
}
